import { render } from "./mygroup.vue?vue&type=template&id=ef8a0f6a&scoped=true&ts=true"
import script from "./mygroup.vue?vue&type=script&lang=ts"
export * from "./mygroup.vue?vue&type=script&lang=ts"

import "./mygroup.vue?vue&type=style&index=0&id=ef8a0f6a&lang=less"
import "./mygroup.vue?vue&type=style&index=1&id=ef8a0f6a&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8a0f6a"]])

export default __exports__